export const DAV_DATA_LOADING = "DAV_DATA_LOADING";
export const DAV_DATA_SUCCESS = "DAV_DATA_SUCCESS";
export const DAV_DATA_FAILED = "DAV_DATA_FAILED";

export const SENT_LINK_LOADING = "SENT_LINK_LOADING";
export const SENT_LINK_SUCCESS = "SENT_LINK_SUCCESS";
export const SENT_LINK_FAILED = "SENT_LINK_FAILED";

export const CHECK_STATUS_LOADING = "CHECK_STATUS_LOADING";
export const CHECK_STATUS_SUCCESS = "CHECK_STATUS_SUCCESS";
export const CHECK_STATUS_FAILED = "CHECK_STATUS_FAILED";

export const SAVE_DAV_LOADING = "SAVE_DAV_LOADING";
export const SAVE_DAV_SUCCESS = "SAVE_DAV_SUCCESS";
export const SAVE_DAV_FAILED = "SAVE_DAV_FAILED";